<template>
<div class="w-full mx-auto pb-20">

  <div v-if="ready && events.length===0" class="italic text-xl text-beige-academy-300">
    {{ $t('slotsCreation.noLessons')}}
  </div>

  <modal resizable name="SlotsCreationForm" />

  <div class="flex lg:flex-row flex-col">
    <div id="calendar" class="w-full">
      <div class="mt-5 mb-2 py-3 pl-2 text-2xl w-full flex justify-between items-center">
        <h1 class="flex justify-start w-full text-2xl tracking-widest">
          {{ $t('slotsCreation.calendarTitle').toUpperCase() }}
        </h1>
      </div>
      <div class="flex justify-start items-center pt-10 lg:hidden">
        <dashboard-button
        @click="createLessons"
        class="mb-10 mx-4"
        :buttonPlaceholder="$t('slotsCreation.button')" />

        <!--<dashboard-button
        @click="addMasterclass"
        class="mb-10 mx-4"
        :buttonPlaceholder="$t('masterclass.add')" />

        <dashboard-button
        @click="addWorkshop"
        class="mb-10 mx-4"
        buttonPlaceholder="Add Workshop" />-->
      </div>
      <vue-cal
        :disable-views="['years', 'year']"
        today-button
        :time-from="timeFrom"
        :time-to="timeTo"
        :time-step="45"
        :events="events"
        class="bg-gray-100 font-sans-serif"
        :on-event-dblclick="onEventClick"
        :editable-events="{
          title: false, drag: false, resize: false, delete: true, create: true }"
        :snap-to-time="15"
        :locale='$i18n.locale'
        :time-cell-height="60"
      />

      <modal resizable name="open-slot-modal" height="auto" :adaptive="true">
        <open-slot-modal :selectedSlot="selectedEvent"
          @delete="areYouSure"
          @edit="editSlot(selectedSlot.id)" />
      </modal>

      <modal resizable name="booked-lesson" height="auto" :adaptive="true">
        <open-booked-lesson
          :selectedEvent="selectedEvent"
          :selectedSlot="selectedSlot"
          @change="changeLesson()" />
      </modal>

      <modal resizable name="locked-slot" height="auto" :adaptive="true">
        <open-locked-slot
          :selectedEvent="selectedEvent"
          :selectedSlot="selectedSlot"
          @updated="resetSlots" />
      </modal>

      <modal resizable name="event-edit-modal" height="auto" :adaptive="true">
        <edit-slot-modal :slotToEdit="editedSlot" :id="selectedEvent.id" :savedSlots="savedSlots"
        @updated="resetSlots" />
      </modal>

      <modal resizable name="delete" height="auto" :adaptive="true">
        <delete-slot :slotId="selectedEvent.id" @deleted="resetSlots" />
      </modal>

      <modal resizable name="change-lesson" height="auto" :adaptive="true" :draggable="true">
        <edit-booked-lesson
        :selectedSlot="selectedSlot"
        :freeConvertedSlots="freeConvertedSlots"
        :slotToEdit="editedSlot"
        :savedSlots="savedSlots" />
      </modal>
    </div>
    <div class=" flex-col justify-start items-center pt-28 hidden lg:flex">
      <dashboard-button
      @click="createLessons"
      class="mb-10 mx-4"
      :buttonPlaceholder="$t('slotsCreation.button')" />

      <!--<dashboard-button
      @click="addMasterclass"
      class="mb-10 mx-4"
      :buttonPlaceholder="$t('masterclass.add')" />

      <dashboard-button
      @click="addWorkshop"
      class="mb-10 mx-4"
      buttonPlaceholder="Add Workshop" />-->
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios';
import DashboardButton from '@/components/DashboardButton.vue';
import SlotsCreationForm from '@/components/modals/SlotsCreationForm.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import {
  getTeacherMasterclasses, getTeacherFreeSlots, getAllTeacherSlots, getTeacherWorkshops,
} from '@/services/TeacherService';
import AddMasterclass from '../modals/AddMasterclass.vue';
import AddWorkshop from '../modals/AddWorkshop.vue';
import OpenSlotModal from '../modals/OpenSlotModal.vue';
import OpenBookedLesson from '../modals/OpenBookedLesson.vue';
import OpenLockedSlot from '../modals/OpenLockedSlot.vue';
import EditSlotModal from '../modals/EditSlotModal.vue';
import DeleteSlot from '../modals/DeleteSlot.vue';
import EditBookedLesson from '../modals/EditBookedLesson.vue';

export default {
  data() {
    return {
      isLogged: true,
      events: [],
      savedSlots: [],
      ready: false,

      selectedEvent: '',
      start: '',
      timeFrom: 24 * 60,
      timeTo: 0 * 60,

      selectedSlot: {},
      freeSlots: [],
      freeConvertedSlots: [],

      editedSlot: {
        day: '',
        start: '',
        end: '',
      },
    };
  },

  components: {
    DashboardButton,
    OpenSlotModal,
    OpenBookedLesson,
    EditSlotModal,
    DeleteSlot,
    EditBookedLesson,
    OpenLockedSlot,
  },

  computed: {
    ...mapGetters({
      beenUpdatedSlots: 'slots/updatedSlots',
      user: 'auth/user',
    }),
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  watch: {
    beenUpdatedSlots() {
      this.getSlots();
      this.updatedSlots(false);
    },

    choosenTimezone() {
      this.resetSlots();
    },
  },

  created() {
    this.getSlots();
  },

  methods: {
    createLessons() {
      this.$modal.show(SlotsCreationForm,
        {
          props: ['id', 'savedSlots'],
          id: this.user.teacher.id,
          savedSlots: this.savedSlots,
        },
        {
          adaptive: true, height: 'auto', clickToClose: false, scrollable: true,
        });
    },

    addMasterclass() {
      this.$modal.show(AddMasterclass,
        {
          props: ['id', 'savedSlots'],
          id: this.user.teacher.id,
          savedSlots: this.savedSlots,
        },
        { adaptive: true, height: 'auto' });
    },

    addWorkshop() {
      this.$modal.show(AddWorkshop,
        {
          props: ['id', 'savedSlots'],
          id: this.user.teacher.id,
          savedSlots: this.savedSlots,
        },
        { adaptive: true, height: 'auto' });
    },

    changeLesson() {
      this.$modal.hide('booked-lesson');
      this.$modal.show('change-lesson');
      this.editedSlot = this.separateDayAndTime(this.selectedEvent);
      this.getFreeSlots();
    },

    getFreeSlots() {
      const now = dayjs.utc();
      const startDate = this.changeDateFormatForCalendarAndDatabase(now);
      this.freeConvertedSlots = [];
      this.freeSlots = [];
      getTeacherFreeSlots(this.user.teacher.id, startDate).then((response) => {
        this.createEventsForCalendar(response.data, this.freeSlots);
        this.freeSlots.forEach((slot) => {
          if (slot.class === 'free') {
            const newSlot = this.separateDayAndTimeFromStringDate(slot);
            newSlot.id = slot.id;
            this.freeConvertedSlots.push(newSlot);
          }
        });
        const firstSlot = this.freeConvertedSlots[0];
        this.existingSlotToPropose = firstSlot;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    onEventClick(event, e) {
      e.stopPropagation();

      this.selectedEvent = event;

      if (event.status === 'masterclass') {
        this.openMasterclassView(event);
        return;
      }

      if (event.class === 'past') {
        return;
      }

      if (event.status === 'free') {
        this.$modal.show('open-slot-modal');
        return;
      }
      if (event.status === 'booked') {
        this.$modal.show('booked-lesson');
        this.getSelectedSlot();
      }
      if (event.status === 'locked') {
        this.$modal.show('locked-slot');
        this.getSelectedSlot();
      }
    },

    resetSlots() {
      this.events = [];
      this.timeFrom = 24 * 60;
      this.timeTo = 0 * 60;
      this.getSlots();
    },

    getSlots() {
      this.ready = false;
      this.savedSlots = [];
      this.events = [];
      getAllTeacherSlots(this.user.teacher.id).then((response) => {
        this.createEventsForCalendar(response.data, this.events);
        this.getMasterclasses();
        this.getWorkshops();
      }).catch((error) => {
        console.log(error);
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    getMasterclasses() {
      getTeacherMasterclasses(this.user.slug).then((response) => {
        this.createEventsForCalendar(response.data, this.events, true);
        this.ready = true;
      }).catch((error) => {
        console.log(error);
        // this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    getWorkshops() {
      getTeacherWorkshops(this.user.teacher.id).then(({ data }) => {
        data.forEach((workshop) => {
          workshop.workshop_days.forEach((day) => {
            const newDay = {
              title: workshop.title.toUpperCase(),
              start: this.changeDateFormatForCalendarAndDatabase(this.convertDateInChoosenTimezone(`${day.day} ${day.start}`)),
              end: this.changeDateFormatForCalendarAndDatabase(this.convertDateInChoosenTimezone(`${day.day} ${day.end}`)),
              class: 'workshop',
              id: workshop.id,
            };
            this.events.push(newDay);
          });
        });
        this.ready = true;
      }).catch((error) => {
        console.log(error);
        // this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    createEventsForCalendar(slotsArrayToConvert, arrayToFill, isMasterclass) {
      slotsArrayToConvert.forEach((slot) => {
        this.savedSlots.push(slot);

        let returnArray = [];
        if (!isMasterclass) {
          returnArray = this.convertSlotForCalendar(slot, this.timeFrom, this.timeTo);
        } else {
          returnArray = this.convertMasterclassForCalendar(slot, this.timeFrom, this.timeTo);
        }
        const newEvent = returnArray.event;
        newEvent.status = slot.status;
        if (slot.student) {
          newEvent.title = slot.student.name;
        }

        if (newEvent.class === 'pending') {
          newEvent.pending_id = slot.pending_id;
          newEvent.class = 'bg-white text-red-600';
          newEvent.title = '<i class="v-icon material-icons">hourglass_full</i>';
        }

        if (newEvent.class === 'locked') {
          newEvent.class = 'bg-white text-red-600';
          newEvent.title = `<i class="v-icon material-icons">error</i></br>${newEvent.title}`;
        }
        if (newEvent.class === 'booked') {
          newEvent.class = `bg-tiers-${slot.color} text-gray-100`;
          if (slot.icon) {
            newEvent.content = `<i class="v-icon material-icons">${slot.icon}</i>`;
          }
        }

        this.timeFrom = returnArray.timeFrom * 60;
        this.timeTo = returnArray.timeTo * 60;

        if (!arrayToFill.some((event) => event.start === newEvent.start)) {
          arrayToFill.push(newEvent);
        }
      });

      // this.setPendingSlotsBgColor();
    },

    /* setPendingSlotsBgColor() {
      const pendingSlots = this.events.filter((event) => event.class === 'pending');

      const pendingIds = [];
      pendingSlots.forEach((slot) => {
        if (!pendingIds.some((id) => id === slot.pending_id)) {
          pendingIds.push(slot.pending_id);
        }
      });

      pendingIds.forEach((id) => {
        const color = `bg-${this.getRandomColor()}-${this.getRandomShade()}`;
        const slots = this.events.filter((slot) => slot.pending_id === id);
        slots.forEach((slot) => {
          const newSlot = slot;
          newSlot.class = `pending ${color}`;
        });
      });
    }, */

    getSelectedSlot() {
      axios.get(`/api/slots/${this.selectedEvent.id}`).then(({ data }) => {
        this.selectedSlot = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    areYouSure() {
      this.$modal.hide('open-slot-modal');
      this.$modal.show('delete');
    },

    editSlot() {
      this.$modal.hide('open-slot-modal');
      this.$modal.show('event-edit-modal');
      this.editedSlot = this.separateDayAndTime(this.selectedEvent);
    },

    getRandomColor() {
      const colors = ['yellow', 'orange', 'pink'];
      return colors[Math.floor(Math.random() * 4)];
    },

    getRandomShade() {
      const shades = ['100', '200', '300', '400', '500'];
      return shades[Math.floor(Math.random() * 4)];
    },
  },
};
</script>

<style lang="scss">
  .D1C4E9FF {
    background-color: #D1C4E9FF;
  }
</style>
